import { type PropsWithChildren } from "react";

import { KanplaLogoNew } from "~/components/KanplaLogoNew";

type ProductPageHeaderProps = PropsWithChildren & {
  onLogoClick?: () => void;
  logoUrl?: string;
  isLoading?: boolean;
};

export const ProductPageHeader = ({
  children,
  onLogoClick,
  isLoading,
  logoUrl
}: ProductPageHeaderProps) => {
  return (
    <div className="flex max-h-36 justify-between gap-4 p-9">
      {isLoading ? (
        <div className="h-16 w-1/5 animate-pulse rounded-xl bg-[#D9D9D9]" />
      ) : (
        <button type="button" onClick={onLogoClick}>
          {logoUrl ? (
            <img src={logoUrl} alt="logo" className="h-20 w-auto" />
          ) : (
            <KanplaLogoNew variant="dark" className="!h-16 !w-auto" />
          )}
        </button>
      )}

      <div className="flex items-center gap-4">{children}</div>
    </div>
  );
};
